<template lang="pug">
  .product-category-tree
    ul.tree-menu
      ProductCategoryTreeItem(
        v-for="(item, i) in tree"
        :info="info"
        :item="item"
        :key="item.id"
        :depth="depth"
        :data="data"
        :budget="budget"
        :currency="currency"
        :class="{ 'is-first': i === 0 }"
      )
        template(v-slot:item="{ item, depth, style }")
            slot(name="item" :item="item" :depth="depth" :style="style")
        .percentage(v-if="i === 0") {{ percentage }}%
</template>

<script>
import { get } from '@/helpers';

import ProductCategoryTreeItem from './ProductCategoryTreeItem';

export default {
    name: 'ProductCategoryTree',
    props: {
        tree: {
            type: Array,
            default: () => []
        },
        data: {
            type: Object,
            default: () => ({})
        },
        budget: {
            type: Number,
            default: 0
        },
        currency: {
            type: String,
            default: 'EUR'
        },
        depth: {
            type: Number,
            default: 1
        },
        info: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ProductCategoryTreeItem
    },
    computed: {
        percentage() {
            let sum = 0;
            this.tree.forEach(el => {
                sum += get(this.data, `percentages.${el.id}`) || 0;
            });
            return sum;
        }
    }
};
</script>

<style lang="sass" scoped>
li.tree-item ul.tree-menu
  padding-left: 1rem
.percentage
  width: 40px
  text-align: center
  margin: 0 4px
</style>
